import { userMasterApi } from '../admin/api/masterApi'
import { getAuthUserId, isAdminAuthenticated } from '../admin/utils/auth'

const validatedUserIds = new Map()

/**
 * Resolve the user_master id for wishlist/cart.
 * Admin logins can have an orphaned reference_id (e.g. 1) that is not in
 * user_master — those must not call /carts or /wishlists.
 */
export async function resolveShopUserId() {
  if (!isAdminAuthenticated()) return null

  const rawId = getAuthUserId()
  const userId = Number(rawId)
  if (!Number.isFinite(userId) || userId <= 0) return null

  if (validatedUserIds.has(userId)) {
    return validatedUserIds.get(userId) ? userId : null
  }

  try {
    const user = await userMasterApi.getOne(userId)
    const ok = user != null && Number(user.user_id) === userId
    validatedUserIds.set(userId, ok)
    return ok ? userId : null
  } catch {
    validatedUserIds.set(userId, false)
    return null
  }
}

export function clearShopUserValidationCache() {
  validatedUserIds.clear()
}

export function getAssetIdFromProduct(product) {
  const raw = product?.product_id ?? product?.service_id ?? product?.asset_id
  const assetId = Number(raw)
  return Number.isFinite(assetId) && assetId > 0 ? assetId : null
}
